// src/navigations/path.jsx - Centralized route paths

// Dashboard
export const DASHBOARD_PATH = '/dashboard';

// Merchant Routes
export const CREATE_MERCHANT = '/create-merchant';
export const IN_UNDERWRITING_PATH = '/in-underwriting';
export const MERCHANT_ACCOUNTS_LIST = '/merchants/accounts';
export const PENDING_PATH = '/pending';
export const COMPLETE_PATH = '/complete';

// User Management Routes
export const USERS_LIST_PATH = '/users-list';
export const TEAMS_LISTS_PATH = '/teams-lists';
export const CREATE_TEAM = '/create-team';
export const CREATE_USER = '/create-user';

// Sales DBA
export const SALES_DBA_LISTING = '/sales-dba';

// Profile
export const PROFILE_PATH = '/profile';
export const Profile_page = '/profile';

// Leads Routes
export const LEADS_PATH = '/leads';
export const LEADS_CREATE_PATH = '/leads/create';

// Permissions
export const ROLE_PERMISSION = '/permission/role';
export const USER_PERMISSION = '/permissions/assign';

// Issues
export const ISSUE_LIST_PAGE = '/issues';

// Contracts
export const CONTRACTS_LIST_PATH = '/contracts';

// Calendar / Meetings
export const CALENDAR_SCHEDULE_PATH = '/meetings/calendar';
export const MEETING_CREATE_PATH = '/meetings/create';
export const MEETING_EDIT_PATH = '/meetings/edit';
export const MEETING_VIEW_PATH = '/meetings/view';